import { TMakeBreadcrumbFn } from './composeMakeBreadcrumb';

export const makeClickBreadcrumb: TMakeBreadcrumbFn = (breadcrumb, hint?) => {
  const result = { ...breadcrumb };

  if (breadcrumb.category === 'ui.click' && hint) {
    const { target } = hint.event as { target: HTMLElement };

    // This will ignore other buttons which may contain PIIs
    // (such as gridcell in date pickers)
    const role = target?.getAttribute('role');
    const textContentAllowedRole = !role || role === 'button';

    const breadcrumbData = {
      ...(role && { role }),
      ...(target?.id && { fieldId: target.id }),
      ...(target?.getAttribute('data-testid') && {
        dataTestId: target.getAttribute('data-testid'),
      }),
      ...(target?.tagName && { tagName: target.tagName }),
      ...(textContentAllowedRole &&
        target?.tagName === 'BUTTON' &&
        target?.textContent && { textContent: target.textContent }),
    };

    result.data = breadcrumbData;
  }

  return result;
};
